import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Flyout from 'Components/UI/Flyout';
import closeModal from 'Helpers/ModalHelper';
import { CircularProgress, Typography } from '@material-ui/core';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import AvailabilityPeriodLinkLayout from 'Components/Modals/InstantBookerModal/AvailabilityPeriodLinkLayout';
import moment from 'moment-timezone';
import { GetAppUrl } from 'Consts/sharedUris';
import { clientSchedulerUri } from 'Consts/clientUris';

const styles = () => ({
  root: {},
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  flyout: {
    width: 450,
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 21,
  },
  metaForm: {
    width: '100%',
  },
});

const InstantBookerModal = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const [availabilityPeriodLinkResource, setAvailabilityPeriodLinkResource] = useState(null);

  const handleCloseInstantBooker = () => {
    closeModal();
  };

  const fetchAvailabilityPeriodLinkResource = async () => {
    const availabilityPeriodLinkCollection = await householdResource?.relationship(fr.relationships.buildSchedulerLink.name).link('related').Get();
    const newResource = availabilityPeriodLinkCollection.create();
    // set with timezone and client url data
    newResource.attr('timezone', moment.tz.guess());
    const schedulerLink = `${GetAppUrl()}${clientSchedulerUri}&link=`;
    newResource.attr('clientUrl', schedulerLink);
    setAvailabilityPeriodLinkResource(newResource);
  };

  useEffect(() => {
    if (householdResource) {
      fetchAvailabilityPeriodLinkResource();
    }
  }, [householdResource]);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Flyout
        open
        anchor="right"
        onClose={handleCloseInstantBooker}
        classes={{
          paper: classes.flyout,
          content: classes.content,
        }}
      >
        {!availabilityPeriodLinkResource ? (
          <CircularProgress className={classes.loading} />
        ) : (
          <>
            <Typography className={classes.title}>
            Allow client to schedule next meeting:
            </Typography>
            <MetaFormInline
              className={classes.metaForm}
              layout={AvailabilityPeriodLinkLayout}
              resource={availabilityPeriodLinkResource}
              noIndividualSubmitButtons
            />
          </>
        )}
      </Flyout>
    </Box>
  );
};

InstantBookerModal.defaultProps = {
  className: '',
};

InstantBookerModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InstantBookerModal);
